"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const lodash_1 = __importDefault(require("lodash"));
function appOrderToApiOrder(appOrder) {
    var _a;
    const valid = !!((appOrder.valid || appOrder.valid === undefined));
    const apiOrder = Object.assign(Object.assign({}, appOrder), { creator: (_a = appOrder === null || appOrder === void 0 ? void 0 : appOrder.creatorId) !== null && _a !== void 0 ? _a : '', batches: toApiBatch(appOrder.batches), payments: toApiPayment(appOrder.payments), customerCount: appOrder.customers, valid: valid });
    if (apiOrder.deliveryType === 'table') {
        delete apiOrder.pickupAt;
    }
    delete apiOrder.summary; // 前端用欄位
    delete apiOrder.paidAmount;
    delete apiOrder.customers; // 改名 customerCount
    delete apiOrder.creatorId; // 改名 creator
    return apiOrder;
}
exports.default = appOrderToApiOrder;
function toApiPayment(appPayments) {
    const payments = lodash_1.default.map(appPayments, appPayment => {
        return Object.assign(Object.assign({}, appPayment), { id: appPayment.id, paymentMethod: appPayment.paymentMethod, paymentCharge: appPayment.paymentCharge, gateway: appPayment.gateway, ref: appPayment.ref, payload: appPayment.payload, amount: Number(appPayment.amount), paidAt: appPayment.paidAt, paidAmount: Number(appPayment.paidAmount), paymentTips: Number(appPayment.paymentTips), change: appPayment.change, remark: appPayment.remark, createdAt: appPayment.createdAt, status: appPayment.status, reason: appPayment.reason, from: 'MERCHANT' });
    }).filter(payment => payment.createdAt !== null);
    return payments;
}
function toApiBatch(appBatches) {
    const batches = lodash_1.default.map(appBatches, appBatch => {
        var _a;
        const apiBatch = Object.assign(Object.assign({}, appBatch), { items: toApiBatchItems(appBatch.items), submittedAt: appBatch.createdAt, creator: { id: (_a = appBatch.creatorId) !== null && _a !== void 0 ? _a : '' } });
        return apiBatch;
    });
    return batches;
}
function toApiOption(appOptions) {
    const options = [];
    lodash_1.default.forEach(appOptions, appOption => {
        options.push(Object.assign(Object.assign({}, appOption), { optionName: appOption.name, optionId: appOption.optionItemId }));
    });
    return options;
}
function toApiBatchItems(appBatchItems) {
    const items = [];
    lodash_1.default.forEach(appBatchItems, appBatchItem => {
        var _a;
        let item;
        if (appBatchItem.isSet) {
            item = Object.assign(Object.assign({}, appBatchItem), { id: appBatchItem.id, total: (_a = appBatchItem.totalWithoutSetItems) !== null && _a !== void 0 ? _a : appBatchItem.total, price: appBatchItem.price + appBatchItem.discount, options: toApiOption(appBatchItem.options), tags: appBatchItem.tags, remarks: appBatchItem.remarks, quantity: 1, category: { id: appBatchItem.categoryId }, menu: { id: appBatchItem.menuId }, setId: appBatchItem.setId, setMenuId: appBatchItem.setId });
            delete item.prices;
            delete item.totals;
            delete item.ids;
            delete item.image;
            items.push(item);
            lodash_1.default.forEach(appBatchItem.setItems, (setItem) => {
                lodash_1.default.forEach(setItem.itemIds, (itemId) => {
                    item = Object.assign(Object.assign({}, setItem), { id: itemId, price: setItem.price + setItem.discount, options: toApiOption(setItem.options), tags: setItem.tags, remarks: setItem.remarks, quantity: 1, category: { id: setItem.categoryId }, menu: { id: setItem.menuId }, setMenuId: appBatchItem.setId });
                    delete item.prices;
                    delete item.totals;
                    delete item.ids;
                    delete item.image;
                    items.push(item);
                });
            });
        }
        else {
            lodash_1.default.forEach(appBatchItem.itemIds, (itemId) => {
                item = Object.assign(Object.assign({}, appBatchItem), { id: itemId, price: appBatchItem.price + appBatchItem.discount, options: toApiOption(appBatchItem.options), tags: appBatchItem.tags, remarks: appBatchItem.remarks, quantity: 1, category: { id: appBatchItem.categoryId }, menu: { id: appBatchItem.menuId }, setId: '', setMenuId: null });
                delete item.prices;
                delete item.totals;
                delete item.ids;
                delete item.image;
                items.push(item);
            });
        }
    });
    return items;
}
//# sourceMappingURL=appOrderToApiOrder.js.map